import { Button } from "antd";
import styled from "styled-components";
import { COLORS } from "../../../../../../components/layout/theme";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 40px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: center;
	align-items: center;
	background-color: ${COLORS.White};
	border-radius: 10px;
	padding: 2rem ;
	gap: 20px;
`;

export const Section = styled.div`
	display: flex;
	width: 100%;
	gap: 20px;
	justify-content: space-between;
	align-items: center;
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 20px 20px;
	display: flex;
	flex-direction: column;
	min-width: 100px;
`;
